const storageConstant = {
    USER: 'user',
    ACCESS_TOKEN: '_token',
    REFRESH_TOKEN: '_rtoken',
}
export default storageConstant
